export class Status {
    id: number
    name: string

    constructor(data) {
        if ( data.statustype1_pk ) {
            this.id = parseInt(data.statustype1_pk);
            this.name = data.status;
        } else if ( data.statustype2_pk ) {
            this.id = parseInt(data.statustype2_pk);
            this.name = data.status;
        } else if (data.status_id) {
            this.id = parseInt(data.status_id);
            this.name = data.name;
        }
    }
}
